import { type FC } from 'react';
import { PriceLevel, PriceLevelSymbols, StarSymbols } from '../../..';
import { type PlaceRecommendation } from '../types';
import { RecommendationCard } from './RecommendationCard';

interface Props {
  readonly recommendation: PlaceRecommendation;
}

const asPriceLevel = (s: string | null): PriceLevel | null => {
  switch (s) {
    case 'PRICE_LEVEL_FREE':
      return PriceLevel.Free;
    case 'PRICE_LEVEL_INEXPENSIVE':
      return PriceLevel.Inexpensive;
    case 'PRICE_LEVEL_MODERATE':
      return PriceLevel.Moderate;
    case 'PRICE_LEVEL_EXPENSIVE':
      return PriceLevel.Expensive;
    case 'PRICE_LEVEL_VERY_EXPENSIVE':
      return PriceLevel.VeryExpensive;
    default:
      return null;
  }
};

export const PlaceCard: FC<Props> = ({
  recommendation: {
    address,
    description,
    google_maps_uri: mapsUrl,
    name,
    phone_number: phoneNumber,
    photo_uri,
    price_level: priceLevel,
    rating,
    url,
  },
}) => (
  <RecommendationCard
    image={photo_uri ? { altText: 'Image provided by Google.', uri: photo_uri } : null}
    name={name}
    url={url}
    subtitleContent={
      rating || asPriceLevel(priceLevel) ? (
        <span className={'icon-text'}>
          {rating ? (
            <>
              <StarSymbols rating={rating} />
              <span>({rating.toFixed(1)})</span>
            </>
          ) : null}
          {asPriceLevel(priceLevel) ? <PriceLevelSymbols priceLevel={asPriceLevel(priceLevel)} /> : null}
        </span>
      ) : null
    }
    address={address ? { formattedAddress: address, mapsUrl } : null}
    phoneNumber={phoneNumber ? { nationalFormat: phoneNumber } : null}
    description={description}
  />
);
PlaceCard.displayName = 'PlaceCard';
